// RTK Query cache tag types — the vocabulary for cache invalidation.
export const TAG_TYPES = {
  Session: 'Session',
  Dashboard: 'Dashboard',
  Contract: 'Contract',
  Declaration: 'Declaration',
  Shipment: 'Shipment',
  // Account-setup lookups that form dropdowns read.
  Site: 'Site',
  BackToBackAccount: 'BackToBackAccount',
  Material: 'Material',
  Supplier: 'Supplier',
  Customer: 'Customer',
  Order: 'Order',
  OutgoingShipment: 'OutgoingShipment',
  Allocation: 'Allocation',
  Inventory: 'Inventory',
  Transaction: 'Transaction',
  User: 'User',
  ActivityLog: 'ActivityLog',
};

export const TAG_TYPE_LIST = Object.values(TAG_TYPES);

// Sub-list tags: one cache entry per parent, shared by the slices and the link wizards.
export const linkedShipmentsTag = (contractId) => ({
  type: TAG_TYPES.Contract,
  id: `LINKED_SHIPMENTS-${contractId}`,
});
export const linkableShipmentsTag = (contractId) => ({
  type: TAG_TYPES.Contract,
  id: `LINKABLE_SHIPMENTS-${contractId}`,
});
export const siteMaterialsTag = (siteId) => ({
  type: TAG_TYPES.Site,
  id: `MATERIALS-${siteId}`,
});
export const siteMbPeriodTag = (siteId) => ({
  type: TAG_TYPES.Site,
  id: `MB_PERIOD-${siteId}`,
});
export const accountMbPeriodsTag = {
  type: TAG_TYPES.Site,
  id: 'MB_PERIODS',
};
// The same id lookupsApi's getCustomerShippingDetails provides, so a site save refreshes "Sold to" dropdowns.
export const customerShippingTag = (customerId) => ({
  type: TAG_TYPES.Customer,
  id: `SHIPPING-${customerId}`,
});
export const customerSitesTag = (customerId) => ({
  type: TAG_TYPES.Customer,
  id: `SITES-${customerId}`,
});
export const customerTransportTag = (customerId) => ({
  type: TAG_TYPES.Customer,
  id: `TRANSPORT-${customerId}`,
});
export const linkedContractsTag = (shipmentId) => ({
  type: TAG_TYPES.Shipment,
  id: `LINKED_CONTRACTS-${shipmentId}`,
});
export const linkableContractsTag = (shipmentId) => ({
  type: TAG_TYPES.Shipment,
  id: `LINKABLE_CONTRACTS-${shipmentId}`,
});
export const linkedShipmentsForDeclarationTag = (declarationId) => ({
  type: TAG_TYPES.Declaration,
  id: `LINKED_SHIPMENTS-${declarationId}`,
});
export const linkableShipmentsForDeclarationTag = (declarationId) => ({
  type: TAG_TYPES.Declaration,
  id: `LINKABLE_SHIPMENTS-${declarationId}`,
});
